import React from 'react';
import { Chart, ReactGoogleChartEvent } from 'react-google-charts';
import { ChartResponse } from '@/api/tax-guide';

export function PieChart({
  data,
  onCompleteRender,
}: {
  data: ChartResponse;
  onCompleteRender: () => void;
}) {
  const color_array = data.chartData.map(item => item.bgColor);
  const pieChartData = [];
  pieChartData.push(['Element', 'Percentage' as unknown as number]);
  data.chartData.map(item => {
    pieChartData.push([item.name, Number(item.value)]);
  });

  const chartEvents: ReactGoogleChartEvent[] = [
    {
      eventName: 'ready',
      callback: onCompleteRender,
    },
  ];
  const options = {
    height: 250,
    top: 80,
    title: data.title,
    chartArea: {
      width: '100%',
      height: '85%',
    },
    slices: {
      0: {
        offset: 0.08,
      },
    },
    colors: color_array,
    pieSliceText: 'none',
    pieSliceTextStyle: {
      color: 'black',
    },
    legend: {
      position: 'labeled',
      labeledValueText: 'both',
    },
    tooltip: {
      trigger: 'none',
    },
  };

  return (
    <div id={`generated-chart-${data.divId}`}>
      <Chart
        chartType="PieChart"
        data={pieChartData}
        options={options}
        chartEvents={chartEvents}
      />
    </div>
  );
}
